import { useCopyToClipboard } from '@/presentation/hooks/useCopyToClipboard';
import Tooltip from '@/presentation/components/ui/Tooltip';
import Icon, { Icons } from '../Icon';
import type { IconProps } from '../Icon/Icon';
import { useCallback, useEffect, useState } from 'react';

const Copy = ({
  size = 16,
  copyText,
  className,
}: {
  size: IconProps['size'];
  copyText: string;
  className?: string;
}) => {
  const [copied, setCopied] = useState(false);
  const [, copy] = useCopyToClipboard();

  const onCopyClick = useCallback(() => {
    copy(copyText);
    setCopied(true);
    setTimeout(() => setCopied(false), 1000);
  }, [copy, copyText]);

  return (
    <Tooltip
      content={copied ? 'Copied!' : 'Copy to clipboard'}
      label={
        <span onClick={onCopyClick} className={`${className} cursor-pointer`}>
          <Icon
            name={copied ? Icons.CHECK : Icons.DOCUMENT_DUPLICATE}
            className="text-gray-500 hover:text-gray-800"
            size={size}
          />
        </span>
      }
    />
  );
};

export default Copy;
